<template>
  <div :style="themeStyle">
      <v-container>
          <v-row class="pt-10">
              <v-col class="text-center">
                <v-img src="/static/img/404.svg" max-width="317" style="margin:0 auto" />
              </v-col>
          </v-row>
          <v-row>
              <v-col class="text-center pt-0"><span class="headline2 font20 weight1000">ขออภัย<br>ไม่พบหน้าที่คุณต้องการ</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  rounded
                  class="btn_icon1"
                  :style="{'color': $CUSTOMMainTextColor}"
                  dark
                  @click="$router.push('/')"
                >
                  กลับหน้าหลัก
                </v-btn>
              </v-col>
            </v-row>
      </v-container>
  </div>
</template>
<script>
export default {
  name: '404',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page404.vue